import {platformView} from "../Helpers/platformView";

interface Tvideo {
	status: 'ready' | 'over'
}

export const video: Tvideo = {
	status: 'ready',
}
export const videoHandler = () => {
	const blurOverlay = document.querySelector("#video-blur-overlay") as HTMLElement;
	const desktopBlurOverlay = document.querySelector("#desktop-video-blur-overlay") as HTMLElement;
	const floatingLogo = document.getElementById("floating-logo")
	const videoEl = document.querySelector(platformView() ? '#welcome-video-mobile' : '#welcome-video-desktop') as HTMLVideoElement;
	// Elements to hide during video playback
	const pausedVideoBadges = document.querySelector("#paused-video-badges") as HTMLElement;
	const mobileTitle = document.querySelector("#main-title") as HTMLElement;
	const kostenlosBadge = document.querySelector("#kostenlos-badge") as HTMLElement;
	const mobileSubtitle = document.querySelector("#main-subtitle") as HTMLElement;
	const swipeIndicator = document.querySelector(".animate-bounce") as HTMLElement;
	// Elements to show on video playing
	const muteButton = document.querySelector("#volume-down-desktop") as HTMLElement;
	const muteButtonMobile = document.querySelector("#volume-down-mobile") as HTMLElement;
	// Mobile video handler
	if (videoEl.paused) {
		if (platformView()) {
			videoEl.src = videoEl.dataset.url;
			videoEl.play();
			muteButtonMobile.classList.remove("hidden");
			video.status = 'over';
			// Hide mobile UI elements immediately
			if (mobileTitle) mobileTitle.style.display = "none";
			if (mobileSubtitle) mobileSubtitle.style.display = "none";
			if (swipeIndicator && swipeIndicator.parentElement) swipeIndicator.parentElement.style.display = "none";
			if (kostenlosBadge) kostenlosBadge.style.display = "none";

			setTimeout(() => {
				blurOverlay.classList.remove("hidden");
				const videoImg = document.querySelector("#welcome-video-mobile") as HTMLElement;
				videoImg.style.filter = "blur(10px)";
				if (floatingLogo) floatingLogo.style.display = "none";
				// video mute
				videoEl.muted = true;
			}, 10000);
		} else {
			videoEl.src = videoEl.dataset.url;
			videoEl.play();
			// Desktop video handler - DO NOT hide title/subtitle on desktop
			muteButton.classList.remove("hidden");
			if (pausedVideoBadges) pausedVideoBadges.style.display = "none";
			// Only show blur overlay on desktop, keep titles visible
			setTimeout(() => {
				desktopBlurOverlay.classList.remove("hidden");
				const desktopVideoImg = document.querySelector("#welcome-video-desktop") as HTMLElement;
				desktopVideoImg.style.filter = "blur(10px)";
				// mute video
				videoEl.muted = true
			}, 10000);
		}
	}
};
